import React, { useState, useRef, useEffect, useCallback } from 'react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { db } from '../../src/firebaseConfig';
import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  doc,
  getDoc,
  runTransaction
} from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import './RegisterSales.css';
import backgroundImage from '../assets/background1.jpg';
import styles from './PlatformAccounts.module.css';
import lottie from 'lottie-web';
import loadingBear from '../assets/loadingBear.json';
import moment from 'moment-timezone';


function RegisterSales() {
  const [saleDate, setSaleDate] = useState(new Date());
  const [saleType, setSaleType] = useState('');
  const [unitPrice, setUnitPrice] = useState(0);
  const [quantity, setQuantity] = useState(1); // será forzada a 1
  const [totalSales, setTotalSales] = useState(0);
  const [investment, setInvestment] = useState(0);
  const [totalProfit, setTotalProfit] = useState(0);

  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);

  const [phoneNumber, setPhoneNumber] = useState('');
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const [selectedCode, setSelectedCode] = useState('');

  // NUEVO: perfiles disponibles para el código elegido
  const [availableProfiles, setAvailableProfiles] = useState([]); // [{key, displayName, pin}]
  const [profilesLoading, setProfilesLoading] = useState(false);
  const [selectedProfileKey, setSelectedProfileKey] = useState('');
  const [selectedProfilePin, setSelectedProfilePin] = useState('');

  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [loadingVenta, setLoadingVenta] = useState(false);
  const [plataformas, setPlataformas] = useState([]); 

  const loadingBearRef = useRef(null);
  const navigate = useNavigate();

  const backgroundStyle = {
    minHeight: '100vh',
    width: '100%',
    margin: 0,
    padding: 0,
    backgroundImage: `linear-gradient(
      rgba(0, 0, 0, 0.75),
      rgba(0, 0, 0, 0.65)
    ), url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    overflowX: 'hidden'
  };

  // Nueva función para obtener plataformas desde Firebase
const fetchPlataformas = useCallback(async () => {
  try {
    const snapshot = await getDocs(collection(db, 'plataformas'));
    const data = snapshot.docs.map(doc => ({ 
      id: doc.id, 
      ...doc.data() 
    }));
    // Ordenar alfabéticamente por nombre
    data.sort((a, b) => a.nombre.localeCompare(b.nombre));
    setPlataformas(data);
  } catch (error) {
    console.error("Error al obtener plataformas:", error);
    // Fallback a plataformas estáticas en caso de error
    setPlataformas([
      { id: 'netflix', nombre: 'Netflix', imagen: '' },
      { id: 'max', nombre: 'MAX', imagen: '' },
      { id: 'disney', nombre: 'Disney plus', imagen: '' },
      // ... otras plataformas básicas
    ]);
  }
}, []);

  useEffect(() => {
    if (loadingVenta && loadingBearRef.current) {
      const animation = lottie.loadAnimation({
        container: loadingBearRef.current,
        animationData: loadingBear,
        renderer: 'svg',
        loop: true,
        autoplay: true,
      });
      return () => animation.destroy();
    }
  }, [loadingVenta]);

  // Forzamos cantidad = 1 siempre
  useEffect(() => {
    if (quantity !== 1) setQuantity(1);
  }, [quantity]);

      // Cargar plataformas al montar el componente
    useEffect(() => {
      fetchPlataformas();
    }, [fetchPlataformas]);


  const calculateTotals = () => {
    const q = 1; // fijo
    const totalSalesValue = unitPrice * q;
    const totalProfitValue = totalSalesValue - investment;
    setTotalSales(totalSalesValue);
    setTotalProfit(totalProfitValue);
  };

  const adjustToLocalMidnight = (date) => {
    const adjustedDate = new Date(date);
    adjustedDate.setHours(0, 0, 0, 0);
    return adjustedDate;
  };

  // Buscar cuentas por plataforma
  const fetchAccounts = async (platform) => {
    setLoading(true);
    setAccounts([]);
    try {
      const accountsRef = collection(db, 'Cuentas');
      const q = query(accountsRef, where('plataforma', '==', platform), where('pantallas', '>', 0));
      const snap = await getDocs(q);
      if (!snap.empty) {
        const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setAccounts(data);
      } else {
        setAccounts([]);
      }
    } catch (err) {
      console.error('Error buscando cuentas:', err);
      alert('Error buscando cuentas: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePlatformChange = (e) => {
    const platform = e.target.value;
    setSaleType(platform);
    setSelectedCode('');
    setAvailableProfiles([]);
    setSelectedProfileKey('');
    setSelectedProfilePin('');

    if (platform) fetchAccounts(platform);
    else setAccounts([]);
  };

  // NUEVO: leer perfiles disponibles (vendido === false) para el código seleccionado
const fetchAvailableProfiles = async (codigo) => {
  setProfilesLoading(true);
  setAvailableProfiles([]);
  setSelectedProfileKey('');
  setSelectedProfilePin('');
  try {
    // Buscar por el campo codigo en lugar del ID del documento
    const profilesRef = collection(db, 'profiles');
    const q = query(profilesRef, where('codigo', '==', codigo));
    const querySnapshot = await getDocs(q);
    
    if (querySnapshot.empty) {
      setAvailableProfiles([]);
      return;
    }
    
    // Tomar el primer documento (debería ser único por código)
    const doc = querySnapshot.docs[0];
    const data = doc.data();
    const perfilesMap = data?.perfiles || {};
    const list = Object.entries(perfilesMap)
      .filter(([, v]) => v && v.vendido === false)
      .map(([key, v]) => ({ key, displayName: v.displayName, pin: v.pin }));
    setAvailableProfiles(list);
  } catch (err) {
    console.error('Error leyendo perfiles:', err);
    alert('Error leyendo perfiles: ' + err.message);
  } finally {
    setProfilesLoading(false);
  }
};

  const handleCodeChange = (e) => {
    const code = e.target.value;
    setSelectedCode(code);
    if (code) fetchAvailableProfiles(code);
    else {
      setAvailableProfiles([]);
      setSelectedProfileKey('');
      setSelectedProfilePin('');
    }
  };

  const handleSelectProfile = (e) => {
    const key = e.target.value;
    setSelectedProfileKey(key);
    const found = availableProfiles.find((p) => p.key === key);
    setSelectedProfilePin(found ? found.pin : '');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!phoneNumber || !startDate || !endDate || !selectedCode || !saleType) {
      alert("Por favor, completa todos los campos requeridos.");
      return;
    }
    if (!selectedProfileKey) {
      alert('Debes seleccionar un perfil disponible.');
      return;
    }
    if (unitPrice <= 0) {
      alert('Ingresa un precio unitario válido.');
      return;
    }

    setLoadingVenta(true);

    try {
      const adjustedSaleDate = adjustToLocalMidnight(saleDate);

      // Ubicar el doc de Cuentas por código
      const accountsRef = collection(db, 'Cuentas');
      const accountQuery = query(accountsRef, where('codigo', '==', selectedCode));
      const querySnapshot = await getDocs(accountQuery);
      if (querySnapshot.empty) {
        alert('No se encontró el documento correspondiente en la colección Cuentas.');
        return;
      }
      const accountDoc = querySnapshot.docs[0];

      // Buscar el documento de profiles por código
      const profilesQuery = query(collection(db, 'profiles'), where('codigo', '==', selectedCode));
      const profilesSnapshot = await getDocs(profilesQuery);
      if (profilesSnapshot.empty) {
        alert('No se encontraron perfiles para este código.');
        return;
      }
      const profilesRef = profilesSnapshot.docs[0].ref;

      // Transacción: valida y actualiza pantallas y vendido
      await runTransaction(db, async (tx) => {
        // Releer ambos dentro de la transacción
        const accSnap = await tx.get(accountDoc.ref);
        if (!accSnap.exists()) throw new Error('Cuenta no encontrada durante la transacción.');

        const pantallas = accSnap.data().pantallas || 0;
        if (pantallas <= 0) throw new Error('No hay pantallas disponibles.');

        const profSnap = await tx.get(profilesRef);
        if (!profSnap.exists()) throw new Error('Perfiles no encontrados para este código.');

        const perfilesMap = profSnap.data()?.perfiles || {};
        const perfil = perfilesMap[selectedProfileKey];
        if (!perfil) throw new Error('El perfil seleccionado no existe.');
        if (perfil.vendido !== false) throw new Error('El perfil ya fue vendido.');

        // Actualizaciones atómicas
        tx.update(accountDoc.ref, { pantallas: pantallas - 1 });
        tx.update(profilesRef, { [`perfiles.${selectedProfileKey}.vendido`]: true });
      });

    
    await addDoc(collection(db, 'Ventas'), {
      saleDate: adjustedSaleDate.toISOString(),
      saleType,
      unitPrice,
      quantity: 1,
      totalSales,
      investment,
      totalProfit,
      phoneNumber,
      startDate: startDate.toISOString(),
      endDate: moment(endDate).tz('America/Bogota').startOf('day').toISOString(),
      codigo: selectedCode,
      perfil: availableProfiles.find(p => p.key === selectedProfileKey)?.displayName || 'N/A',
      pin: selectedProfilePin || 'N/A'
    });

      // Datos del modal (solo para mostrar/copiar, NO persistidos en Ventas)
      setModalData({
        cuenta: {
          codigo: accountDoc.data().codigo,
          correo: accountDoc.data().correo,
          contrasena: accountDoc.data().contrasena,
          plataforma: accountDoc.data().plataforma,
          pais: accountDoc.data().pais || 'N/A',
        },
        venta: {
          phoneNumber,
          profile: availableProfiles.find(p => p.key === selectedProfileKey)?.displayName || 'N/A',
          pin: selectedProfilePin || 'N/A',
          startDate: startDate.toISOString(),
          endDate: moment(endDate).tz('America/Bogota').startOf('day').toISOString(),
        },
      });
      setShowModal(true);

      // Reset
      setSaleDate(new Date());
      setSaleType('');
      setUnitPrice(0);
      setQuantity(1);
      setTotalSales(0);
      setInvestment(0);
      setTotalProfit(0);
      setPhoneNumber('');
      setStartDate(new Date());
      setEndDate(new Date());
      setSelectedCode('');
      setAvailableProfiles([]);
      setSelectedProfileKey('');
      setSelectedProfilePin('');

    } catch (error) {
      console.error('Error guardando la venta:', error);
      alert('Error al agregar la venta: ' + error.message);
    } finally {
      setLoadingVenta(false);
    }
  };

  const handleCancel = () => navigate('/home');

  const copyToClipboard = () => {
    const textToCopy = `
🐻 *¡Gracias por tu compra!* 🐻

Aquí tienes el resumen de tu compra:
🪪 Código: \`${modalData.cuenta?.codigo || "N/A"}\`
📱 Número: ${modalData.venta?.phoneNumber || "N/A"}
📺 Servicio: _${modalData.cuenta?.plataforma || "N/A"}_
📧 Correo: ${modalData.cuenta?.correo || "N/A"}
🔐 Contraseña: ${modalData.cuenta?.contrasena || "N/A"}
👥 Perfil: _${modalData.venta?.profile || "N/A"}_
🗝️ Pin: ${modalData.venta?.pin || "N/A"}
🗓️ Vence: ${modalData.venta?.endDate ? new Date(modalData.venta.endDate).toLocaleDateString() : "N/A"}

🌐 https://bear-max.web.app/
WhatsApp: +57 320 7499845

🐾 BearMax Team🐾
`;
    navigator.clipboard.writeText(textToCopy)
      .then(() => alert('Información copiada al portapapeles.'))
      .catch((err) => {
        console.error('Error al copiar la información:', err);
        alert('No se pudo copiar la información. Intenta nuevamente.');
      });
  };

  return (
    <>
      {loadingVenta && (
        <div className="loading-overlay">
          <div className="loading-animation" ref={loadingBearRef}></div>
          <p className="loading-text">Registrando la venta... 🐻</p>
        </div>
      )}

      <div style={backgroundStyle}>
        <div className="suscriptions-accounts-container">
          <h2 className={styles['title']}>Registro de Ventas</h2>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Selecciona la Plataforma</label>
              <select value={saleType} onChange={handlePlatformChange} required>
                <option value="">Selecciona un servicio</option>
                {plataformas.map(p => (
                  <option key={p.id} value={p.nombre}>{p.nombre}</option>
                ))}
                <option value="Otro">Otro</option>
              </select>
            </div>

            {loading ? (
              <p>Cargando cuentas...</p>
            ) : accounts.length > 0 ? (
              <div className="accounts-table-container">
                <table className={styles['accounts-table']}>
                  <thead>
                    <tr>
                      <th>Código</th>
                      <th>Correo</th>
                      <th>Contraseña</th>
                      <th>Pantallas</th>
                    </tr>
                  </thead>
                  <tbody>
                    {accounts.map((account, index) => (
                      <tr
                        key={account.id}
                        onClick={() => setSelectedRow(index)}
                        className={selectedRow === index ? "selected-row" : ""}
                      >
                        <td>{account.codigo}</td>
                        <td>{account.correo}</td>
                        <td>{account.contrasena}</td>
                        <td>{account.pantallas}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : saleType && !loading ? (
              <p>No se encontraron cuentas para la plataforma seleccionada.</p>
            ) : null}

            {accounts.length > 0 && (
              <div className="form-group">
                <label>Selecciona el Código de Cuenta</label>
                <select value={selectedCode} onChange={handleCodeChange} required>
                  <option value="">Selecciona un código</option>
                  {accounts.map((account) => (
                    <option key={account.id} value={account.codigo}>
                      {account.codigo}
                    </option>
                  ))}
                </select>
              </div>
            )}

            {/* NUEVO: selector de perfil disponible */}
            {selectedCode && (
              <div className="form-group">
                <label>Perfil disponible</label>
                {profilesLoading ? (
                  <p>Cargando perfiles...</p>
                ) : availableProfiles.length > 0 ? (
                  <select value={selectedProfileKey} onChange={handleSelectProfile} required>
                    <option value="">Selecciona un perfil</option>
                    {availableProfiles.map((p) => (
                      <option key={p.key} value={p.key}>
                        {p.displayName}
                      </option>
                    ))}
                  </select>
                ) : (
                  <p>No hay perfiles disponibles (no vendidos) para este código.</p>
                )}
              </div>
            )}

            {/* Mostrar PIN (solo lectura) */}
            {selectedProfileKey && (
              <div className="form-group">
                <label>PIN del perfil</label>
                <input type="text" value={selectedProfilePin} readOnly />
                <small>Este PIN no se puede modificar, es estatico ojo ps</small>
              </div>
            )}

            {/* Datos del cliente y fechas */}
            <br />
            <div className="form-group">
              <label>Número de Teléfono</label>
              <input
                type="tel"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="Ingresa el número de teléfono"
                required
              />
            </div>

            <br />
            <div className="form-group">
              <label>Fecha de Finalización</label>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                className="input"
                required
              />
            </div>

            <br />
            <div className="form-group">
              <label>Fecha de Venta</label>
              <DatePicker
                selected={saleDate}
                onChange={(date) => setSaleDate(date)}
                className="input"
                required
              />
            </div>

            {/* Precio / Ganancia */}
            <br />
            <div className="form-group">
              <label>Precio Unitario</label>
              <input
                type="number"
                value={unitPrice}
                onChange={(e) => setUnitPrice(Number(e.target.value))}
                onBlur={calculateTotals}
                placeholder="Ingresa el precio unitario"
                required
                min="0"
              />
            </div>

            <br />
            {/* Cantidad bloqueada en 1 */}
            <div className="form-group">
              <label>Cantidad</label>
              <input type="number" value={1} readOnly className="input" />
              <small>Una venta corresponde a un perfil.</small>
            </div>

            <br />
            <div className="form-group">
              <label>Total Ventas</label>
              <input type="number" value={totalSales.toFixed(2)} readOnly className="input" />
            </div>

            <br />
            <div className="form-group">
              <label>Inversión</label>
              <input
                type="number"
                value={investment}
                onChange={(e) => setInvestment(Number(e.target.value))}
                onBlur={calculateTotals}
                placeholder="Ingresa la inversión"
                required
                min="0"
              />
            </div>

            <br />
            <div className="form-group">
              <label>Total Ganancia</label>
              <input type="number" value={totalProfit.toFixed(2)} readOnly className="input" />
            </div>

            <div className="button-group">
              <button type="submit" className={`${styles.searchButton}`}>Registrar Venta</button>
              <button type="button" className={styles['transparentFullButton']} onClick={handleCancel}>
                Cancelar
              </button>
            </div>
          </form>

          {showModal && (
            <div className="modal">
              <div className="modal-content">
                <h2>Detalles de la Venta Registrada</h2>
                <h3>Información de la Cuenta</h3>
                <p><strong>Código:</strong> {modalData.cuenta?.codigo}</p>
                <p><strong>Correo:</strong> {modalData.cuenta?.correo}</p>
                <p><strong>Contraseña:</strong> {modalData.cuenta?.contrasena}</p>
                <p><strong>Plataforma:</strong> {modalData.cuenta?.plataforma}</p>
                <p><strong>País:</strong> {modalData.cuenta?.pais}</p>

                <h3>Información de la Venta</h3>
                <p><strong>Número de Teléfono:</strong> {modalData.venta?.phoneNumber}</p>
                <p><strong>Perfil:</strong> {modalData.venta?.profile}</p>
                <p><strong>Pin:</strong> {modalData.venta?.pin}</p>
                <p><strong>Fecha de Inicio:</strong> {new Date(modalData.venta?.startDate).toLocaleDateString()}</p>
                <p><strong>Fecha de Finalización:</strong> {new Date(modalData.venta?.endDate).toLocaleDateString()}</p>

                <button onClick={copyToClipboard} className="btn save">Copiar Información</button>
                <button onClick={() => setShowModal(false)} className="btn cancel">Cerrar</button>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default RegisterSales;
